import React from 'react';
import { CusProductListPaginationProps } from '../../cus-product-list.data';
import useProductListPagination, { buildPageWindow } from '../../hooks/usePagination';

export default function ProductListPagination({ props, currentPage, totalPages, onPageChange }: CusProductListPaginationProps) {
    const { goToNextPageText, paginationAriaLabel, previousPageLabel, nextPageLabel, pageAriaLabel } = props.resources;
    const { isFirstPage, isLastPage, handlePage } = useProductListPagination({ currentPage, totalPages, onPageChange });
    const pages = buildPageWindow(currentPage, totalPages);

    return (
        <nav className='bs-product-list__pagination' aria-label={paginationAriaLabel}>
            <button
                className='bs-product-list__pagination-next-btn'
                onClick={() => handlePage(currentPage + 1)}
                disabled={isLastPage}
                aria-disabled={isLastPage}
            >
                {goToNextPageText}
            </button>

            <div className='bs-product-list__pagination-controls' role='group'>
                <button
                    className='bs-product-list__pagination-btn bs-product-list__pagination-btn--chevron'
                    onClick={() => handlePage(currentPage - 1)}
                    disabled={isFirstPage}
                    aria-disabled={isFirstPage}
                    aria-label={previousPageLabel}
                >
                    &#8249;
                </button>

                {pages.map((page, index) => {
                    if (page === 'ellipsis') {
                        return (
                            <span
                                key={`ellipsis-${index}`}
                                className='bs-product-list__pagination-btn bs-product-list__pagination-btn--ellipsis'
                                aria-hidden='true'
                            >
                                &hellip;
                            </span>
                        );
                    }

                    const isActive = page === currentPage;
                    return (
                        <button
                            key={page}
                            className={`bs-product-list__pagination-btn${isActive ? ' bs-product-list__pagination-btn--active' : ''}`}
                            onClick={() => handlePage(page)}
                            aria-current={isActive ? 'page' : undefined}
                            aria-label={pageAriaLabel.replace('{0}', String(page))}
                        >
                            {page}
                        </button>
                    );
                })}

                <button
                    className='bs-product-list__pagination-btn bs-product-list__pagination-btn--chevron'
                    onClick={() => handlePage(currentPage + 1)}
                    disabled={isLastPage}
                    aria-disabled={isLastPage}
                    aria-label={nextPageLabel}
                >
                    &#8250;
                </button>
            </div>
        </nav>
    );
}
